import {h, Fragment} from "preact"
import { SearchResultsV2 as SearchResults } from '../'
import { useCustomConfig } from '../../hooks/useCustomConfig'

const defaultSearches = [
    {
        keyword: "Dresses"
    },
    {
        keyword: "Rompers"
    },
    {
        keyword: "Skirts"
    },
    {
        keyword: "Swim"
    },
    {
        keyword: "Denim"
    },
]

export default function History () {

    const { customConfig } = useCustomConfig();
    const topSearches = customConfig.searchDefaults ? 
        customConfig.searchDefaults.split(',').map(searchTerm => ({ keyword: searchTerm.trim() })) 
        : defaultSearches;

    return (
        <>
        
            <SearchResults topSearches={topSearches} />
        </>
    )
}